import React from 'react'
import { Card, Button, Dropdown } from "react-bootstrap"
import {
  FaPhone,
  FaEnvelope,
  FaCommentAlt,
  FaEdit,
  FaUser,
  FaFileAlt,
  FaMapMarkerAlt,
  FaStickyNote,
  FaEllipsisV,
  FaCalendarAlt,
  FaChevronDown,
  FaList,
  FaTh,
  FaTable,
  FaWhatsapp,
  FaTrashAlt,
  FaClock,
  FaChevronLeft,
  FaChevronRight,
  FaPalette,
  FaClipboard,
  FaLayerGroup,
  FaPlus
} from "react-icons/fa"

import Select from 'react-select';
import LeadConst from '../../../util/LeadConst';

const HeaderActions = ({ 
  // State props
  showActionMenu, 
  showDesignMenu, 
  
  // Toggle handlers
  onToggleActionMenu, 
  onToggleDesignMenu,
  onAddActivity,
  
  // Data props
  lead,
  iItem,
  lItem,
  models,
  option,
  
  // Permission props
  NoteAdd,
  CallAdd,
  MeetAdd,
  Property,
  Update,
  Delete,
  CloudCall,
  EmailAdd,
  DocAdd,
  SmsAdd,
  SalesAdd,
  QuoteAdd,
  ContactAdd,
  
  // Action handlers
  onPrev,
  onNext,
  onDesignChange,
  onProperties,
  showPopUp
}) => {
  
  const handlePrev = () => {
    if (onPrev && iItem > 1) onPrev();
  }

  const handleNext = () => {
    if (onNext && iItem < lItem) onNext();
  }

  const getDesignOptions = () => [
    { label: 'Tab View', value: 1 }, 
    { label: 'List View', value: 2 }, 
    { label: 'Compact', value: 3 }, 
    { label: 'Modern', value: 4 }
  ];

  const getAvailableActions = () => {
    const actions = [{ label: 'WhatsApp', action: LeadConst.WhatsApp }];
    
    if (NoteAdd) { 
      actions.push({ 
        label: models?.note?.model_name || 'Note', 
        action: LeadConst.Note,
        icon: <FaClipboard size={16} />
      }); 
    }
    
    if (EmailAdd) { 
      actions.push({ 
        label: models?.email?.model_name || 'Email', 
        action: LeadConst.Email,
        icon: <FaEnvelope size={16} />
      }); 
    }
    
    if (DocAdd) { 
      actions.push({ 
        label: models?.document?.model_name || 'Document', 
        action: LeadConst.Document,
        icon: <FaFileAlt size={16} />
      }); 
    }
    
    if (SmsAdd) { 
      actions.push({ 
        label: models?.sms?.model_name || 'SMS', 
        action: LeadConst.SMS,
        icon: <FaCommentAlt size={16} />
      }); 
    }
    
    if (SalesAdd) { 
      actions.push({ 
        label: models?.sales_order?.model_name || 'Sales Order', 
        action: LeadConst.SalesOrder,
        icon: <FaFileAlt size={16} />
      }); 
    }
    
    if (QuoteAdd) { 
      actions.push({ 
        label: models?.quote?.model_name || 'Quote', 
        action: LeadConst.Quote,
        icon: <FaFileAlt size={16} />
      }); 
    }
    
    if (ContactAdd) { 
      actions.push({ 
        label: models?.contact?.model_name || 'Contact', 
        action: LeadConst.Contact,
        icon: <FaUser size={16} />
      }); 
    }
    
    if (Delete) { 
      actions.push({ 
        label: 'Delete', 
        action: LeadConst.Delete,
        icon: <FaTrashAlt size={16} />,
        className: 'text-danger'
      }); 
    }
    
    actions.push({ 
      label: 'History', 
      action: LeadConst.History,
      icon: <FaClock size={16} />
    });
    
    return actions;
  };

  const handleActionSelect = (actionType) => {
    if (showPopUp) showPopUp(null, actionType);
  };

  const handleCall = () => {
    if (CallAdd && showPopUp) showPopUp(null, LeadConst.Call);
  };

  const handleMeeting = () => {
    if (MeetAdd && showPopUp) showPopUp(null, LeadConst.Meeting);
  };

  const handleNote = () => {
    if (NoteAdd && showPopUp) showPopUp({}, LeadConst.Note);
  };

  const handleEdit = () => {
    if (Update && showPopUp) showPopUp(null, LeadConst.Edit);
  };

  const handleCloudCall = () => {
    if (CloudCall && showPopUp) showPopUp(null, LeadConst.CloudCall);
  };

  const handleWhatsApp = () => {
    if (showPopUp) showPopUp(null, LeadConst.WhatsApp);
  };

  return (
    <Card style={{ 
      backgroundColor: 'white', 
      borderRadius: '8px', 
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)', 
      border: '1px solid #e5e7eb', 
      padding: '8px',
      marginBottom: '8px'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '8px', flexWrap: 'wrap' }}>
        
        {/* Previous/Next Navigation */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {iItem > 1 && (
            <Button 
              variant="outline-secondary" 
              onClick={handlePrev}
              style={{ 
                width: '36px', 
                height: '36px', 
                borderRadius: '8px', 
                padding: '0', 
                display: 'inline-flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                color: '#4b5563',
                borderColor: '#d1d5db'
              }}
              className="nav-btn"
            >
              <FaChevronLeft size={18} />
            </Button>
          )}
          {iItem < lItem && (
            <Button 
              variant="outline-secondary" 
              onClick={handleNext}
              style={{ 
                width: '36px', 
                height: '36px', 
                borderRadius: '8px', 
                padding: '0', 
                display: 'inline-flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                color: '#4b5563',
                borderColor: '#d1d5db'
              }}
              className="nav-btn"
            >
              <FaChevronRight size={18} />
            </Button>
          )}
        </div>
        
        <div style={{ width: '1px', height: '24px', backgroundColor: '#d1d5db', margin: '0 4px' }}></div>

        {/* Design Selector */}
        <Dropdown show={showDesignMenu} onToggle={onToggleDesignMenu}>
          <Dropdown.Toggle 
            variant="outline-secondary" 
            style={{ 
              display: 'inline-flex', 
              alignItems: 'center', 
              gap: '8px', 
              padding: '8px 12px', 
              fontSize: '14px', 
              fontWeight: '500', 
              color: '#374151', 
              backgroundColor: 'transparent', 
              border: '1px solid #d1d5db', 
              borderRadius: '8px'
            }}
            className="design-btn"
          >
            <FaPalette size={16} />
            Design
            <FaChevronDown size={14} />
          </Dropdown.Toggle>
          <Dropdown.Menu style={{ 
            position: 'absolute', 
            left: 0, 
            marginTop: '8px', 
            width: '160px', 
            backgroundColor: 'white', 
            borderRadius: '8px', 
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)', 
            border: '1px solid #e5e7eb' 
          }}>
            {getDesignOptions().map((opt) => (
              <Dropdown.Item 
                key={opt.value}
                onClick={() => onDesignChange(opt)}
                style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '8px', 
                  padding: '8px 16px', 
                  fontSize: '14px', 
                  color: '#374151',
                  backgroundColor: option?.value === opt.value ? '#f3f4f6' : 'white'
                }}
                className="dropdown-item"
              >
                {opt.value === 1 && <FaTable size={16} />}
                {opt.value === 2 && <FaList size={16} />}
                {opt.value === 3 && <FaTh size={16} />}
                {opt.value === 4 && <FaTable size={16} />}
                {opt.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>

        <div style={{ width: '1px', height: '24px', backgroundColor: '#d1d5db', margin: '0 4px' }}></div>

        {/* Primary Action Buttons */}
        {CallAdd && (
          <Button 
            variant="outline-primary" 
            onClick={handleCall}
            style={{ 
              display: 'inline-flex', 
              alignItems: 'center', 
              gap: '8px', 
              padding: '8px 12px', 
              fontSize: '14px', 
              fontWeight: '500', 
              backgroundColor: 'transparent', 
              border: '1px solid #2563eb', 
              borderRadius: '8px',
              color: '#2563eb'
            }}
            className="call-btn"
          >
            <FaPhone size={14} />
            {models?.call?.model_name || 'Call'}
          </Button>
        )}

        {MeetAdd && (
          <Button 
            variant="outline-primary" 
            onClick={handleMeeting}
            style={{ 
              display: 'inline-flex', 
              alignItems: 'center', 
              gap: '8px', 
              padding: '8px 12px', 
              fontSize: '14px', 
              fontWeight: '500', 
              backgroundColor: 'transparent', 
              border: '1px solid #7c3aed', 
              borderRadius: '8px',
              color: '#7c3aed'
            }}
            className="meeting-btn"
          >
            <FaCalendarAlt size={14} />
            {models?.meeting?.model_name || 'Meeting'}
          </Button>
        )}

        {/* WhatsApp Button */}
        <Button 
          variant="outline-success"
          onClick={handleWhatsApp}
          style={{ 
            display: 'inline-flex', 
            alignItems: 'center', 
            gap: '8px', 
            padding: '8px 12px', 
            fontSize: '14px', 
            fontWeight: '500', 
            backgroundColor: 'transparent', 
            border: '1px solid #22c55e', 
            borderRadius: '8px',
            color: '#22c55e'
          }}
          className="whatsapp-btn"
        >
          <FaWhatsapp size={16} />
          WhatsApp
        </Button>

        {/* Additional Buttons */}
        {CloudCall && (
          <Button 
            variant="outline-secondary"
            onClick={handleCloudCall}
            style={{ 
              display: 'inline-flex', 
              alignItems: 'center', 
              gap: '6px', 
              padding: '8px 12px', 
              fontSize: '14px', 
              fontWeight: '500', 
              backgroundColor: 'transparent', 
              border: '1px solid #6b7280', 
              borderRadius: '8px',
              color: '#6b7280'
            }}
            className="cloudcall-btn"
          >
            Cloud Call
          </Button>
        )}

        {/* More Actions Dropdown */}
        <Dropdown show={showActionMenu} onToggle={onToggleActionMenu}>
          <Dropdown.Toggle 
            variant="outline-secondary" 
            style={{ 
              display: 'inline-flex', 
              alignItems: 'center', 
              gap: '6px', 
              padding: '8px 12px', 
              fontSize: '14px', 
              fontWeight: '500', 
              color: '#374151', 
              backgroundColor: 'transparent', 
              border: '1px solid #d1d5db', 
              borderRadius: '8px'
            }}
            className="more-actions-btn"
          >
            <FaEllipsisV size={16} />
            More Actions
          </Dropdown.Toggle>
          <Dropdown.Menu style={{ 
            position: 'absolute', 
            right: 0, 
            marginTop: '8px', 
            width: '200px', 
            backgroundColor: 'white', 
            borderRadius: '8px', 
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)', 
            border: '1px solid #e5e7eb' 
          }}>
            {getAvailableActions().map((action, index) => (
              <Dropdown.Item 
                key={index}
                onClick={() => handleActionSelect(action.action)}
                style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '8px', 
                  padding: '8px 16px', 
                  fontSize: '14px', 
                  color: action.className === 'text-danger' ? '#dc2626' : '#374151'
                }}
                className="dropdown-item"
              >
                {action.icon}
                {action.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>

        {Update && (
          <Button 
            variant="outline-secondary" 
            onClick={handleEdit}
            style={{ 
              display: 'inline-flex', 
              alignItems: 'center', 
              gap: '6px', 
              padding: '8px 12px', 
              fontSize: '14px', 
              fontWeight: '500', 
              color: '#374151', 
              backgroundColor: 'transparent', 
              border: '1px solid #d1d5db', 
              borderRadius: '8px' 
            }}
            className="edit-btn"
          >
            <FaEdit size={16} />
            Edit
          </Button>
        )}
      </div>

      {/* Hover Styles */}
      <style jsx>{`
        /* Navigation buttons hover */
        .nav-btn:hover {
          background-color: #6b7280 !important;
          color: white !important;
          border-color: #6b7280 !important;
        }
        
        /* Design button hover */
        .design-btn:hover {
          background-color: #6b7280 !important;
          color: white !important;
          border-color: #6b7280 !important;
        }
        
        /* Call button hover - Blue */
        .call-btn:hover {
          background-color: #2563eb !important;
          color: white !important;
        }
        
        /* Meeting button hover - Purple */
        .meeting-btn:hover {
          background-color: #7c3aed !important;
          color: white !important;
        }
        
        /* WhatsApp button hover - Green */
        .whatsapp-btn:hover {
          background-color: #22c55e !important;
          color: white !important;
        }
        
        /* Cloud Call button hover - Gray */
        .cloudcall-btn:hover {
          background-color: #6b7280 !important;
          color: white !important;
        }
        
        /* More Actions button hover */
        .more-actions-btn:hover {
          background-color: #6b7280 !important;
          color: white !important;
          border-color: #6b7280 !important;
        }
        
        /* Edit button hover */
        .edit-btn:hover {
          background-color: #4b5563 !important;
          color: white !important;
          border-color: #4b5563 !important;
        }
        
        /* Dropdown items hover */
        .dropdown-item:hover {
          background-color: #f3f4f6 !important;
        }
        
        /* Button transitions */
        button {
          transition: all 0.2s ease-in-out !important;
        }
      `}</style>
    </Card>
  )
}

export default HeaderActions